import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { infoService } from "../services";
import { getLength } from 'ol/sphere';
import { MapTool } from '../tools';

export const ModifyOverlay = props => {

    let [defaultFeature, setDefaultFeature] = useState(null);

    let [modifiedFeature, setModifiedFeature] = useState(null);

    const [selectedLayerId, setSelectedLayerId] = useState(null);

    const [selectedTableName, setSelectedTableName] = useState(null);

    const [position, setPosition] = useState(null);

    let mapTool = props.map.current.mapTool;

    useEffect(() => {

        initiliazeDefaultInteractions();

    }, []);

    useEffect(() => {
        console.log(modifiedFeature);
    }, [modifiedFeature])

    useEffect(() => {
        if (props.wfsOperationResult) {
            if (props.wfsOperationResult == "success") {

                mapTool.clearSelectInteraction("select_edit_interaction");

                mapTool.setDoubleClickZoomActive(true);

                if (props.wfsModifyMeasure) {
                    document.getElementById("modify-feature-measure").innerHTML = "";
                }
            }
            else {
                document.getElementById("wfs_modify_action_buttons").style.display = "flex";
                if (props.wfsModifyMeasure) {
                    document.getElementById("modify-feature-measure").style.display = "flex";
                }
            }
            props.wfsOperationResultFunc(null);
        }

    }, [props.wfsOperationResult])

    const apply = () => {
        infoService.executeRule({
            wkt: MapTool.convertToWktWithDecimalOption(modifiedFeature, mapTool.wktProjection, mapTool.mapProjection),
            tableName: selectedTableName,
            id: modifiedFeature.get("id")
        }, props.dynamicRuleApiUrl).
            then(response => {

                if (!response.success) {
                    props.toastRef.current.show({
                        severity: 'error',
                        detail: response.message,
                        life: 3000
                    });
                    return;
                }
                if (response.data) {

                    document.getElementById("wfs_modify_action_buttons").style.display = "none";
                    if (props.wfsModifyMeasure) {
                        document.getElementById("modify-feature-measure").style.display = "none";
                    }

                    mapTool.setDoubleClickZoomActive(true);

                    if (props.onSuccess) {

                        props.onSuccess(
                            {
                                defaultFeature: defaultFeature,
                                modifiedFeature: modifiedFeature,
                                selectedLayerId: selectedLayerId,
                                selectedTableName: selectedTableName
                            }
                        );
                    }
                }
                else {

                    props.toastRef.current.show({
                        severity: 'error',
                        detail: response.message,
                        life: 3000
                    });
                }

            }).
            catch(ex => {

                console.error(ex);

                props.toastRef.current.show({
                    severity: 'error',
                    detail: "Beklenmeyen bir hata oluştu!",
                    life: 3000
                });

            }).finally(() => {
            })
    }

    const remove = () => {
        if (props.onDelete) {

            document.getElementById("wfs_modify_action_buttons").style.display = "none";
            if (props.wfsModifyMeasure) {
                document.getElementById("modify-feature-measure").style.display = "flex";
            }
            props.onDelete(
                {
                    defaultFeature: defaultFeature,
                    modifiedFeature: modifiedFeature,
                    selectedLayerId: selectedLayerId,
                    selectedTableName: selectedTableName
                }
            );
        }
    }

    const info = () => {

        if (modifiedFeature != null) {
            let html = "<div class='info-div'>";
            let leftSide = "<div>";
            let rightSide = "<div>";
            for (var key in modifiedFeature.values_) {
                if (key != "GEOLOC" && key != "MI_STYLE" && key != "geometry") {
                    leftSide = leftSide + "<b class='left-side'>" + key + ":</b>";
                    rightSide = rightSide + "<b class='right-side'> " + (modifiedFeature.values_[key] ? modifiedFeature.values_[key] : "-") + "</b>"
                }
            }
            html = html + leftSide + "</div>" + rightSide + "</div>" + "</div>"
            document.getElementById('popup-content').innerHTML = html;

            mapTool.setPopupPosition(position, "popupOverlay", "popup-closer");
        }
    }

    const cancel = () => {

        if (modifiedFeature != null) {
            mapTool.setFeatureGeometry(modifiedFeature, defaultFeature);
        }

        mapTool.clearSelectInteraction("select_edit_interaction");

        document.getElementById("wfs_modify_action_buttons").style.display = "none";

        if (props.wfsModifyMeasure) {
            document.getElementById("modify-feature-measure").innerHTML = "";
            document.getElementById("modify-feature-measure").style.display = "none";
        }

        mapTool.enableOrDisableModifyToolInteraction(false);

        mapTool.setDoubleClickZoomActive(true);

        const infoPopup = document.getElementById("popup-closer");
        if (infoPopup) {
            infoPopup.click();
        }
    }

    const reset = () => {
        if (modifiedFeature != null) {
            mapTool.setFeatureGeometry(modifiedFeature, defaultFeature);
        }

        mapTool.clearSelectInteraction("select_edit_interaction");

        mapTool.clearSelectInteraction("select_hover_interaction");

        document.getElementById("wfs_modify_action_buttons").style.display = "none";

        if (props.wfsModifyMeasure) {
            document.getElementById("modify-feature-measure").innerHTML = "";
            document.getElementById("modify-feature-measure").style.display = "none";
        }

        mapTool.setDoubleClickZoomActive(true);

        const infoPopup = document.getElementById("popup-closer");
        if (infoPopup) {
            infoPopup.click();
        }
    }

    const resetModifyFeature = () => {

        setDefaultFeature(null);

        setModifiedFeature(null);
    }

    const initiliazeDefaultInteractions = () => {

        let layers = mapTool.getMapVectorLayers();

        const checkSelectEditInteraction = mapTool.getInteraction("select_edit_interaction");

        if (!checkSelectEditInteraction) {
            const selectEditInteraction = mapTool.createCustomSelectInteraction({ name: "select_edit_interaction", layers: layers });

            selectEditInteraction.on("select", (e) => {

                if (e.selected.length == 0) {
                    return;
                }

                setSelectedLayerId(selectEditInteraction.getLayer(e.selected[0]).values_.name.split('-').pop());
                setSelectedTableName(e.selected[0].id_.split('.')[0]);
                resetModifyFeature();

                const clonedFeature = e.selected[0].clone();
                const clonedProperties = JSON.parse(JSON.stringify(e.selected[0].getProperties()));
                clonedProperties.geometry = clonedFeature.getGeometry();

                defaultFeature = clonedFeature;
                setDefaultFeature(clonedFeature);

                modifiedFeature = clonedFeature;
                setModifiedFeature(clonedFeature);

                if (props.showModifyButtons) {
                    mapTool.disableInteraction("select_hover_interaction");

                    document.getElementById("wfs_modify_action_buttons").style.display = "flex";

                    if (props.wfsModifyMeasure) {
                        document.getElementById("modify-feature-measure").innerHTML = "";
                    }

                    mapTool.setOverlayPosition("modify-feature-overlay", e.mapBrowserEvent.coordinate);

                    setPosition(e.mapBrowserEvent.coordinate);
                }

            });

            selectEditInteraction.setActive(false);

            mapTool.addInteraction(selectEditInteraction);

            selectEditInteraction.on("change:active", (e) => {
                if (e.oldValue && e.target && !e.target.get("active")) {
                    reset();
                }
            })
        }

        const checkSelectHoverInteraction = mapTool.getInteraction("select_hover_interaction");
        if (!checkSelectHoverInteraction) {

            const selectHoverInteraction = mapTool.createCustomSelectInteraction({
                name: "select_hover_interaction",
                layers: layers,
                condition: mapTool.createHoverCondition(),
                style: function (feature) {
                    feature.changed();

                    if (feature.getGeometry().getType() == "Point") {
                        return mapTool.selectPointHoverStyle;
                    }
                    return mapTool.selectHoverStyle;
                }
            });

            mapTool.addInteraction(selectHoverInteraction);
        }

        if (props.showModifyButtons) {
            const checkModifyInteraction = mapTool.getInteraction("modify_interaction");
            if (!checkModifyInteraction) {
                const modify_interaction = mapTool.createModifyInteraction("modify_interaction", undefined, mapTool.getSelectInteractionFeatures("select_edit_interaction"));

                modify_interaction.on("modifystart", (e) => {

                    mapTool.setDoubleClickZoomActive(false);

                    document.getElementById("wfs_modify_action_buttons").style.display = "none";

                    const feature = e.features.getArray()[0];
                    var coordinate = e.mapBrowserEvent.coordinate;

                    if (props.wfsModifyMeasure && feature.getGeometry().getType() === 'LineString') {

                        feature.getGeometry().on('change', function (e) {

                            const geom = e.target;

                            document.getElementById("modify-feature-measure").style.display = "flex";

                            document.getElementById("modify-feature-measure").innerHTML = formatLength(geom);

                            mapTool.setOverlayPosition("modify-feature-measure", coordinate);

                        });

                    }

                });

                modify_interaction.on("modifyend", (e) => {

                    const feature = e.features.getArray()[0];
                    modifiedFeature = feature;
                    setModifiedFeature(feature);

                    document.getElementById("wfs_modify_action_buttons").style.display = "flex";

                    mapTool.setOverlayPosition("modify-feature-overlay", e.mapBrowserEvent.coordinate);
                    if (props.wfsModifyMeasure) {
                        mapTool.setOverlayPosition("modify-feature-measure", e.mapBrowserEvent.coordinate);
                    }
                    setPosition(e.mapBrowserEvent.coordinate);

                });

                mapTool.addInteraction(modify_interaction);
            }
        }
    }

    const formatLength = function (line) {

        const length = getLength(line);

        return Math.round(length * 100) / 100 + ' ' + 'm';

    };

    return (
        <>
            <>
                <div id="wfs_modify_action_buttons">
                    {
                        props.showModifyButtons &&
                        <>
                            <div className='flex'>
                                <Button id="btn_cancel_modify" style={{ marginRight: '3px' }} onClick={cancel} severity="warning" icon='pi pi-times' />
                                <Button id="btn_apply_modify" style={{ marginRight: '3px' }} onClick={apply} severity="success" icon='pi pi-check' />
                                <Button id="btn_apply_modify" style={{ marginRight: '3px' }} onClick={remove} severity="danger" icon='pi pi-trash' />
                                <Button id="btn_info_feature" onClick={info} color='orange' icon='pi pi-info' />
                            </div>
                            <p className="info-selected-layer">{selectedTableName}</p>
                        </>
                    }
                </div>
                {
                    props.wfsModifyMeasure &&
                    <div id="modify-feature-measure"></div>
                }
            </>
        </>
    )
}

export default ModifyOverlay;
